import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ConvocationService} from '../../../services/convocation.service';
import {Convocation} from '../../../model/convocation';

@Component({
    selector: 'app-my-convocations',
    templateUrl: './my-convocations.component.html',
    styleUrls: ['./my-convocations.component.css'],
    standalone: false
})
export class MyConvocationsComponent implements OnInit {
  myConvocations: Convocation[] = [];

  @Output()
  contentAvailable = new EventEmitter<boolean>();

  constructor(private convocationService: ConvocationService) {
  }

  ngOnInit() {
    this.convocationService
      .getMyConvocations(5)
      .subscribe((data: Convocation[]) => {
        this.myConvocations = data;
        this.contentAvailable.emit(this.myConvocations.length > 0);
      });
  }
}
